import { Heading } from "@twilio-paste/core/heading";
import { Text } from "@twilio-paste/core/text";
import { graphql, useStaticQuery } from "gatsby";
import { SitesQuery } from "queries";
import React from "react";
import { addPrefixAndUpdateInternalLinks } from "../../helper";

const ComponentHeaderBasic: React.FC<{ name: string }> = ({ name }) => (
    <Heading as="h1" variant="heading10">
        {name}
    </Heading>
);

export const PackageValue: React.FC = ({ children }) => (
    <Text as="dd" display="inline-block">
        {children}
    </Text>
);

export const PackageLabel: React.FC = ({ children }) => (
    <Text as="dt" display="inline-block" color="colorTextWeak" css={{ width: "80px" }}>
        {children}
    </Text>
);

const ComponentHeader: React.FC<{ entity: { name: string; classdesc: string } }> = ({ entity }) => {
    const name = entity.name;
    let classdesc = entity.classdesc;
    const query = graphql`
        {
            pages: allSitePage {
                nodes {
                    path
                }
            }
        }
    `;
    const { pages }: SitesQuery = useStaticQuery(query);
    classdesc = addPrefixAndUpdateInternalLinks(classdesc, pages.nodes);

    return (
        <>
            <ComponentHeaderBasic name={name} />
            <div dangerouslySetInnerHTML={{ __html: classdesc! }} />
        </>
    );
};

export { ComponentHeader };
